// Helpers compartidos del módulo Motor de cálculo.

export const fmtEUR = (n) =>
  `€${Number(n || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true, minimumGroupingDigits: 1 })}`;

export const fmtUSD = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtPct = (n) =>
  `${Number(n || 0).toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`;

export const newItem = () => ({
  description: "",
  country: "",
  cost_tax_excl: "",
  cost_tax_incl: "",
  qty: 1,
});

export const COMMISSION_MODES = [
  { value: "none", label: "Sin comisión" },
  { value: "additive", label: "Aditiva (+)" },
  { value: "deductive", label: "Deductiva (÷)" },
];

export const SCOPE_LABELS = { future: "Futuros", all: "Todos", specific: "Específicos" };

export const PARTNER_LABELS = {
  kimkim: "KimKim",
  zicasso: "Zicasso",
  responsible_travel: "Responsible Travel",
  baboo: "Baboo",
  travel_agent_10: "Travel Agent 10%",
  travel_agent_12: "Travel Agent 12%",
  travel_agent_15: "Travel Agent 15%",
  direct: "Directo",
  other: "Otro",
};
